<template>
  <div class="page-container">
    <header class="page-header">
      <div class="d-flex align-items-center">
        <portal-target name="sidebar-toggle" class="d-flex align-items-center mt-1"/>
        <h4 class="mb-0">{{ title }}</h4>
      </div>
      <div class="d-flex align-items-center">
        <b-button id="table-settings" class="custom-btn-secondary mr-1" v-b-toggle.sidebar-fields>
          <v-icon name="buttons/cog" :size="13"/>
        </b-button>
        <b-tooltip target="table-settings" triggers="hover" custom-class="custom-tooltip" noninteractive>
          Колонки
        </b-tooltip>
      </div>
    </header>

    <div class="page-body">
      <div class="page-filters">
        <filters-drawer
          :query.sync="filters.query"
          :is-busy="isBusy"
          :filter-tags="activeFilterTags"
          :disabled-submit="isStartDateEmpty"
          @remove-tag="removeFilterTag"
          @submit="onSearch"
          @clear="onClearFilters"
        >
          <b-col cols="12">
            <label class="small text-muted">Период</label>
            <b-row class="align-items-center">
              <b-col>
                <b-form-input
                  id="input_start_date"
                  size="sm"
                  type="date"
                  v-model.date="filters.start_date"
                  :state="isStartDateEmpty ? false : null"
                />
              </b-col>
              <b-col cols="auto" class="px-2">
                <span>&mdash;</span>
              </b-col>
              <b-col>
                <b-form-input
                  id="input_end_date"
                  size="sm"
                  type="date"
                  v-model.date="filters.end_date"
                />
              </b-col>
            </b-row>
          </b-col>
          <b-col v-if="isStartDateEmpty">
            <small class="text-danger">Укажите дату начала периода!</small>
          </b-col>
          <b-col cols="12" class="mt-1">
            <label class="small text-muted">Заказчик</label>
              <b-input-group>
                <b-form-input
                  id="input_customer"
                  ref="customer_select"
                  size="sm"
                  type="text"
                  readonly
                  :placeholder="$t('message.tasks.modal.customerPlaceholder')"
                  v-model="customer.name">
                </b-form-input>
                <b-input-group-append>
                  <b-btn size="sm" variant="outline-success" @click.stop="showCustomerTable()">
                    Выбрать
                  </b-btn>
                  <b-btn size="sm" @click.stop="removeCustomer()">
                    <font-awesome-icon icon="times-circle"/>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
          </b-col>
          <b-col cols="12" class="mt-1">
            <label class="small text-muted">Объект</label>
            <b-form-select
              id="select_location"
              style="min-width: 150px"
              size="sm"
              v-model="filters.location_id">
              <option :value="0">Все объекты</option>
              <option v-for="option in location_options" :value="option.value">
                {{ option.text }}
              </option>
            </b-form-select>
          </b-col>
        </filters-drawer>
      </div>

      <div class="page-table-container">
        <b-table
          id="customer-stat"
          ref="customer_stat"
          class="custom-table mb-0 text-small"
          sticky-header
          selectable
          select-mode="single"
          responsive
          show-empty
          :empty-text="$t('message.common.emptyTable')"
          :busy.sync="isBusy"
          :items="items"
          :fields="renderedFields"
          :current-page="currentPage"
          :per-page="perPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :filter="filters.query"
          @filtered="onFiltered"
        >
          <template #table-busy>
            <tables-skeleton :fields="renderedFields" :rows="5"/>
          </template>

          <template #cell(task_id)="row">
            <b-button size="sm" variant="link" style="color: #1A9167 !important;" @click.stop="showTask(row)">
              {{row.item.task_id}}
            </b-button>
          </template>

          <template #cell(start_date)="row">
            {{formatTableDateTime(row.item.start_date)}}
          </template>

          <template #cell(total_hours)="row">
            {{ priceFormat(row.item.total_hours) }} {{ getStatsUnitShortName(row.item.unit_code) }}
          </template>
        </b-table>
      </div>

      <div class="page-pagination">
        <pagination-footer
          use-router
          :current-page.sync="currentPage"
          :total-rows="totalRows"
          :per-page.sync="perPage"
          :page-options="pageOptions"
          @page-click="onPagination"
          @per-page-change="onPerPageChange"
        >
          <template #footer-list>
            <div>
              Заявок: <b>{{totalRows}}</b> |
              Кол-во: <b>{{ unitTotalsText }}</b> |
              С заказчика: <b>{{ priceFormat(totalCustomer) }}</b> |
              Исполнителям: <b>{{ priceFormat(totalWorkerPrice) }}</b>
            </div>
          </template>
        </pagination-footer>
      </div>
    </div>

    <customer-table-select ref="customerTable" :town="0" @selectCustomer="updateCustomer"/>

    <DynamicTables
      storage-key="customerStatistic_columns"
      sidebar-fields="sidebar-fields"
      :fields-model.sync="fields"
      fieldKey="task_id"
    />
  </div>
</template>

<script>
import statistics from "../../network/statistics";
import locations from "../../network/locations";
import customers from "../../network/customers";
import unitsStore from "../../utilites/unitStore";
  import dateFormatter from '../../utilites/dateFormatter'
  import helpers from "../../utilites/helpers";
  import DynamicTables from "../../utilites/commonUi/DynamicTables.vue";
  import FiltersDrawer from "../../utilites/commonUi/FiltersDrawer.vue";
  import pageSearchService from "../../utilites/pageSearchService";
  import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";
  import TablesSkeleton from "../../utilites/commonUi/TablesSkeleton.vue";
    import CustomerTableSelect from "../Customers/CustomerTableSelect";

export default {
  name: 'CustomerStatistics',
  components: { TablesSkeleton, PaginationFooter, FiltersDrawer, DynamicTables, CustomerTableSelect },
  mixins: [
    statistics, locations, customers,
    dateFormatter, helpers, pageSearchService, unitsStore
  ],
  data() {
    return {
      title: 'Статистика по заказчикам',
      formUrl: 'statistics/customers',
      sortBy: 'task_id',
      sortDesc: false,
      customer: {},
      customersUrl: 'customers',
      location_options: [],
      items: [],
      fields: [
        {
          key: 'task_id',
          label: this.$t('message.tasks.table.name'),
          sortable: true,
          visible: true,
        },
        {
          key: 'customer_name',
          label: this.$t('message.tasks.table.customer'),
          sortable: true,
          visible: true,
        },
        {
          key: 'customer_contact',
          label: this.$t('message.tasks.table.contact'),
          sortable: true,
          visible: true,
        },
        {
          key: 'start_address',
          label: this.$t('message.tasks.table.start_address'),
          sortable: true,
          visible: true,
        },
        {
          key: 'start_date',
          label: this.$t('message.tasks.table.start_date'),
          sortable: true,
          class:'widthDate',
          visible: true,
        },
        {
          key: 'price_hour',
          label: this.$t('message.tasks.table.payment_first'),
          sortable: true,
          visible: true,
        },
        {
          key: 'total_hours',
          label: 'Кол-во',
          sortable: true,
          visible: true,
        },
        {
          key: 'total_price',
          label: this.$t('message.tasks.table.total_price'),
          sortable: true,
          visible: true,
        },
        {
          key: 'executor_name',
          label: this.$t('message.tasks.table.executor_name'),
          sortable: true,
          visible: true,
        }
      ],
      pageOptions: [50, 100, 500, { value: 10000, text: 'Все'}],
      isBusy: false,
      unitTotalsText: "",
      totalCustomer: 0,
      totalWorkerPrice: 0,
      filters: this.getDefaultFilters(),
    }
  },
  async created() {
    this.isBusy = true;
    const query = this.$route.query;

    if (query) {
      if (query.start_date) {
        this.filters.start_date = query.start_date;
      } else {
        this.filters.start_date = this.getStartDateFilter();
      }

      if (query.end_date) {
        this.filters.end_date = query.end_date;
      } else {
        this.filters.end_date = this.getEndDateFilter();
      }

      if (query.customer_id) {
        const customer_id = query.customer_id
        this.filters.customer_id = customer_id;
        if (customer_id > 0) {
          await this.getCustomer(query.customer_id);
        }
      }

      if (query.location_id) {
        this.filters.location_id = query.location_id;
      }
    }

    await this.onSearch();
  },
  computed: {
    visibleFields() {
      return this.fields.filter(field => field.visible);
    },
    renderedFields() {
      const allFields = [
        ...this.visibleFields,
      ];
      return this.handleFixedCols(allFields);
    },
    activeFilterTags() {
      const tags = [];
      const defaults = this.getDefaultFilters();
      const start = this.filters.start_date;
      const end = this.filters.end_date;

      if (start || end) {
        let dateTag = '';

        if (start && end) {
          dateTag = `${this.formatTableDate(start)} - ${this.formatTableDate(end)}`;
        } else if (start) {
          dateTag = `с ${this.formatTableDate(start)}`;
        } else {
          dateTag = `по ${this.formatTableDate(end)}`;
        }
        tags.push({ key: 'date', label: dateTag });
      }

      if (this.filters.customer_id !== defaults.customer_id) {
        tags.push({ key: 'customer', label: `Заказчик`});
      }

      if (this.filters.location_id !== defaults.location_id) {
        tags.push({ key: 'location', label: `Объект`,});
      }

      return tags;
    },
    isStartDateEmpty() {
      return !this.filters.start_date;
    },
  },
  methods: {
    async getItems() {
      this.totalRows = 0;
      this.unitTotalsText = "";
      this.totalCustomer = 0;
      this.totalWorkerPrice = 0;

      const data = {
        start_date: this.filters.start_date,
        end_date: this.filters.end_date,
        customer_id: this.filters.customer_id,
        location_id: this.filters.location_id,
      }

      this.isBusy = true;
      const result = await this.getCustomerStatistics(data);

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        this.items = [];
        this.isBusy = false;
        return;
      }

      this.items = result.data;
      this.totalRows = result.data.length;
      this.unitTotalsText = this.formatStatsUnitTotals(this.items);

      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i];
        this.updateTotalItem(item)
      }

      this.isBusy = false;
    },
    // Filters
    getDefaultFilters() {
      let filters = {
        query: '',
        start_date: null,
        end_date: null,
        customer_id: 0,
        location_id: 0,
      }

      filters.start_date = this.getStartDateFilter();
      filters.end_date = this.getEndDateFilter();
      return filters;
    },
    onClearFilters() {
      const filters = this.getDefaultFilters();

      if (JSON.stringify(this.filters) === JSON.stringify(filters)) return;

      this.filters = filters;
      this.removeCustomer();
      this.onSearch();
    },
    removeFilterTag(tag) {
      if (tag.key === 'date') {
        this.filters.start_date = this.getStartDateFilter();
        this.filters.end_date = null;
      }
      else if (tag.key === 'customer') {
        this.removeCustomer();
      }
      else if (tag.key === 'location') {
        this.filters.location_id = 0;
      }
      this.onSearch();
    },
    getStartDateFilter() {
      let date = new Date();
      date.setDate(date.getDate() - 15);
      return this.formatDate(date);
    },
    getEndDateFilter() {
      return this.formatDate(new Date());
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
      this.totalDelta = 0;
      this.totalManager = 0;
      this.totalCustomer = 0;
      this.totalWorkerPrice = 0;
      this.unitTotalsText = this.formatStatsUnitTotals(filteredItems);

      for (let index=0;index<filteredItems.length;index++) {
        this.updateTotalItem(filteredItems[index]);
      }
    },
    updateTotalItem(item) {
      this.totalCustomer = this.totalCustomer + item.total_price;
      this.totalCustomer= Math.round(this.totalCustomer * 100) / 100;
      this.totalWorkerPrice = this.totalWorkerPrice + item.total_worker_price;
      this.totalWorkerPrice= Math.round(this.totalWorkerPrice * 100) / 100;
    },
    /*
    exportFile() {
      let start_date = this.getDateToServer(this.filters.start_date).toISOString();
      let end_date = this.getDateToServer(this.filters.end_date).toISOString();

      let url = this.formUrl+"/export"+"?start="+start_date+"&end="+end_date+"&customer_id="+this.filters.customer_id+"&location_id="+this.filters.location_id;

      this.$http.get(url).then(result => {
        this.filePath = result.body.path;
        const url2 = this.$http.options.root+this.filePath;
        window.open(url2,'_black');
      },error =>{
        console.log(error);
      });
    },
     */
    getLocationsByCustomer(customer_id) {
      const url = "locations" + "?customer_id=" + customer_id;
      let self = this;

      return this.$http.get(url).then(result => {
        if (result.status === 403) {
          self.showForbiddenAlert = true;
        } else if (result.status === 200 || result.status === 304) {
          self.showForbiddenAlert = false;
          if (result.body != null) {
            self.location_options = [];
            result.body.items.forEach(function (e) {
              self.location_options.push({value: e.id, text: e.name})
            });
            if (self.location_options.length === 1) {
              self.filters.location_id = this.location_options[0].value;
            }
          } else {
            self.filters.location_id = 0;
            self.location_options = [];
          }
        }
      }, error => {
        console.log("ERROR", error);
      });
    },
    showCustomerTable() {
      this.$refs.customerTable.showModalSelect();
    },
    removeCustomer() {
      this.customer = {};
      this.filters.customer_id = 0;
    },
    updateCustomer(customer) {
      this.customer = customer;
      if (customer.id != null) {
        this.filters.customer_id = customer.id;
      }
    },
    async getCustomer(customerId) {
      const result = await this.getCustomerById(customerId);

      if (!result || !result.data) {
        this.customer = {};
      }

      this.updateCustomer(result.data);
    },
    showTask(row) {
      const isTaskReadOnly = row.item.task_read_only;
      if (isTaskReadOnly) {
        const path = { path: '/tasks/view/' + row.item.task_id};
        const routeData = this.$router.resolve(path);
        window.open(routeData.href, '_blank');
      } else {
        const path = { path: '/tasks/edit/' + row.item.task_id};
        const routeData = this.$router.resolve(path);
        window.open(routeData.href, '_blank');
      }
    },
  },
  watch: {
    'filters.customer_id': {
      handler: function (newVal, oldVal) {
        if (newVal !== undefined) {
          let self = this;
          if (newVal > 0) {
            self.getLocationsByCustomer(newVal);
          } else {
            self.filters.location_id = 0;
            self.location_options = [];
          }
        }
      },
      deep: true
    },
  }
}
</script>

<style>
#customer-stat-pagination {
  margin-bottom: 0;
}

.widthDate {
  width: 170px;
}
</style>



// WEBPACK FOOTER //
// src/components/Statistics/CustomerStatistic.vue